import { render, staticRenderFns } from "./PlayerMetaData.vue?vue&type=template&id=c7bc9e4c"
import script from "./PlayerMetaData.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerMetaData.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports